/**
 * Utility functions for error handling and validation
 */

/**
 * Checks if an error is an HTTP authentication error (401)
 * @param error - The error object to check
 * @returns true if the error is a 401 authentication error
 */
export const isAuthenticationError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;
  const errorWithResponse = error as { response?: { status?: number } };
  return errorWithResponse.response?.status === 401;
};

/**
 * Checks if an error is an HTTP error with a specific status code
 * @param error - The error object to check
 * @param statusCode - The HTTP status code to check for
 * @returns true if the error matches the specified status code
 */
export const isHttpError = (error: unknown, statusCode: number): boolean => {
  if (!error || typeof error !== "object") return false;
  const errorWithResponse = error as { response?: { status?: number } };
  return errorWithResponse.response?.status === statusCode;
};
